import React from 'react';

import moment from 'moment';
import { useIntl } from 'react-intl';

export type DisplayDurationWithSecondsProps = {
  seconds: number;
};

const DisplayDurationWithSeconds: React.FC<DisplayDurationWithSecondsProps> = ({
  seconds,
}) => {
  const intl = useIntl();

  const duration = moment.duration(seconds, 'seconds');

  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const secs = duration.seconds();

  const labelTime = {
    hour: intl.formatMessage({ id: 'general.hour' }),
    hours: intl.formatMessage({ id: 'general.hours' }),
    minute: intl.formatMessage({ id: 'general.minute' }),
    minutes: intl.formatMessage({ id: 'general.minutes' }),
    second: intl.formatMessage({ id: 'general.second' }),
    seconds: intl.formatMessage({ id: 'general.seconds' }),
  };

  // Case: only seconds
  if (hours === 0 && minutes === 0) {
    return `${secs} ${secs !== 1 ? labelTime.seconds : labelTime.second}`;
  }

  // Case: minutes + seconds
  if (hours === 0) {
    return `${minutes} ${
      minutes !== 1 ? labelTime.minutes : labelTime.minute
    } ${secs} ${secs !== 1 ? labelTime.seconds : labelTime.second}`;
  }

  // Case: hours + minutes + seconds
  return `${hours} ${
    hours !== 1 ? labelTime.hours : labelTime.hour
  } ${minutes} ${
    minutes !== 1 ? labelTime.minutes : labelTime.minute
  } ${secs} ${secs !== 1 ? labelTime.seconds : labelTime.second}`;
};

export default DisplayDurationWithSeconds;
